/* ================================================== */
/* FANCYBOX → Topics
/* ================================================== */

$(document).ready(function() {

	$('[data-fancybox="topics"]').fancybox({
		baseClass: "topics topics__fancybox",
		baseTpl:
			'<div class="fancybox-container" role="dialog" tabindex="-1">' +
				'<div class="fancybox-stage"></div>' +
			"</div>",
		touch: false,
		infobar: false
	});

});